import React from 'react';
import {getMergeSortAnimations} from '../sortingAlgorithms/sortingAlgorithms.js';
import {getInsertionSortAnimations} from '../sortingAlgorithms/insertionSort.js';
import {getSelectionSortAnimations} from '../sortingAlgorithms/selectionSort.js';
import { getQuickSortAnimations } from '../sortingAlgorithms/quickSort.js';
import './SortingVisualizer.css';


// Change this value for the speed of the animations.
const ANIMATION_SPEED_MS = 5;

// Change this value for the number of bars (value) in the array.
const NUMBER_OF_ARRAY_BARS = 180;

// This is the main color of the array bars.
const PRIMARY_COLOR = 'turquoise';

// This is the color of array bars that are being compared throughout the animations.
const SECONDARY_COLOR = 'red';

export default class SortingVisualizer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            array: [],
        };
    }

    componentDidMount() {
        this.resetArray();
    }

    resetArray() {
        const array = [];
        for (let i = 0; i < NUMBER_OF_ARRAY_BARS; i++) {
            array.push(randomIntFromInterval(5, 500));
        }
        this.setState({array});
        const arrayBars = document.getElementsByClassName('array-bar');
        for (let i = 0; i < arrayBars.length; i++) {
            arrayBars[i].style.backgroundColor = PRIMARY_COLOR;
        }
    }

    mergeSort() {
        this.toggleButton(true);
        const animations = getMergeSortAnimations(this.state.array);
        for (let i = 0; i < animations.length; i++) {
            const arrayBars = document.getElementsByClassName('array-bar');
            const isColorChange = i % 5 !== 3;
            if (isColorChange) {
                const [barOneIdx, barTwoIdx] = animations[i];
                const barOneStyle = arrayBars[barOneIdx].style;
                const barTwoStyle = arrayBars[barTwoIdx].style;
                if(i % 5 !== 2 && i % 5 !== 4){
                    const color = i % 5 === 0 ? SECONDARY_COLOR : PRIMARY_COLOR;
                    setTimeout(() => {
                        barOneStyle.backgroundColor = color;
                        barTwoStyle.backgroundColor = color;
                    }, i * ANIMATION_SPEED_MS);
                } else {
                    const color = i % 5 === 2 ? 'orange' : PRIMARY_COLOR;
                    setTimeout(() => {
                        barOneStyle.backgroundColor = color;
                    }, i * ANIMATION_SPEED_MS);
                }
                
            } else {
                setTimeout(() => {
                    const [barOneIdx, newHeight] = animations[i];
                    const barOneStyle = arrayBars[barOneIdx].style;
                    barOneStyle.height = `${newHeight * 0.15}vh`;
                    //barOneStyle.opacity = `${(newHeight/500)+0.2}`;
                }, i * ANIMATION_SPEED_MS);
            }
        }
        setTimeout(() => {
            this.toggleButton(false);
        }, (animations.length - 1) * ANIMATION_SPEED_MS);        
    }

    visualizeInsertionSort() {
        this.toggleButton(true);
        const animations = getInsertionSortAnimations(this.state.array);
        for(let i = 0; i < animations.length; i++) {
            const arrayBars = document.getElementsByClassName('array-bar');
            const animationType = animations[i][0];
            const barIdx = animations[i][1];
            const barStyle = arrayBars[barIdx].style;
            switch (animationType) {
                case 'target':
                    const targetColor = animations[i][2] === 'on' ? SECONDARY_COLOR : PRIMARY_COLOR;
                    setTimeout(() => {
                        barStyle.backgroundColor = targetColor;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                case 'position':
                    const positionColor = animations[i][2] === 'on' ? 'orange' : PRIMARY_COLOR;
                    setTimeout(() => {
                        barStyle.backgroundColor = positionColor;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                case 'shift':
                    setTimeout(() => {
                        barStyle.height = `${animations[i][2] * 0.15}vh`;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                default:
            }
        }
        setTimeout(() => {
            this.toggleButton(false);
        }, (animations.length - 1) * ANIMATION_SPEED_MS);
    }

    visualizeSelectionSort() {
        this.toggleButton(true);
        const animations = getSelectionSortAnimations(this.state.array);
        const arrayBars = document.getElementsByClassName('array-bar');
        for (let i = 0; i < animations.length; i++) {
            //const arrayBars = document.getElementsByClassName('array-bar');
            const animationType = animations[i][0];
            const barIdx = animations[i][1];
            const barStyle = arrayBars[barIdx].style;
            switch (animationType) {
                case 'position':
                    const positionColor = animations[i][2] === true ? 'green' : SECONDARY_COLOR;
                    setTimeout(() => {
                        barStyle.backgroundColor = positionColor;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                case 'swap':
                    setTimeout(() => {
                        barStyle.height = `${animations[i][2] * 0.15}vh`;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                case 'scan':
                    const scanColor = animations[i][2] === 'on' ? 'orange' : PRIMARY_COLOR;
                    setTimeout(() => {
                        barStyle.backgroundColor = scanColor;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                case 'min':
                    const minColor = animations[i][2] === true ? 'blue' : PRIMARY_COLOR;
                    setTimeout(() => {
                        barStyle.backgroundColor = minColor;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                default:
            }
        }
        setTimeout(() => {
            this.toggleButton(false);
        }, (animations.length - 1) * ANIMATION_SPEED_MS);
    }

    visualizeQuickSort() {
        this.toggleButton(true);
        const animations = getQuickSortAnimations(this.state.array);
        const arrayBars = document.getElementsByClassName('array-bar');
        for(let i = 0; i < animations.length; i++) {
            const animationType = animations[i][0];
            console.log(animationType);
            const barIdx = animations[i][1];
            const barStyle = arrayBars[barIdx].style;
            switch (animationType) {
                case 'pivot':
                    const pivotColor = animations[i][2] === true ? 'blue' : PRIMARY_COLOR;
                    setTimeout(() => {
                        barStyle.backgroundColor = pivotColor;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                case 'position':
                    const positionColor = animations[i][2] === true ? 'orange' : PRIMARY_COLOR;
                    setTimeout(() => {
                        barStyle.backgroundColor = positionColor;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                case 'scan':
                    const scanColor = animations[i][2] === true ? SECONDARY_COLOR : PRIMARY_COLOR;
                    setTimeout(() => {
                        barStyle.backgroundColor = scanColor;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                case 'swap':
                    setTimeout(() => {
                        barStyle.height = `${animations[i][2] * 0.15}vh`;
                    }, i * ANIMATION_SPEED_MS);
                    break;
                case 'done':
                    setTimeout(() => {
                        barStyle.backgroundColor = 'green';
                    }, i * ANIMATION_SPEED_MS);
                    break;
                default:
            }
        }
        setTimeout(() => {
            this.toggleButton(false);
        }, (animations.length - 1) * ANIMATION_SPEED_MS);
    }

    toggleButton(toggle) {
        const buttons = document.getElementsByTagName('button');
        for (let i = 0; i < buttons.length; i++){
            buttons[i].disabled = toggle;
        }
    }

    render() {
        const {array} = this.state;

        return (
            <div>
                <div className="array-container">
                    {array.map((value, idx) => (
                        <div
                            className="array-bar"
                            key={idx}
                            style={{
                                backgroundColor: PRIMARY_COLOR,
                                height: `${value * 0.15}vh`,
                                //opacity: `${value / 500}`,
                            }}>
                        </div>
                    ))}
                </div>
                <div>
                    <button onClick={() => this.resetArray()}>Generate New Array</button>
                    <button onClick={() => this.mergeSort()}>Merge Sort</button>
                    <button onClick={() => this.visualizeInsertionSort()}>Insertion Sort</button>
                    <button onClick={() => this.visualizeSelectionSort()}>Selection Sort</button>
                    <button onClick={() => this.visualizeQuickSort()}>Quick Sort</button>
                </div>
            </div>
            
        );
    }
}

function randomIntFromInterval(min, max) {
    // min and max are included
    return Math.floor(Math.random() * (max - min + 1) + min);
}